(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cp-eased-disclosure"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-eased-disclosure')) {
    let viewportLocks = 0;
    let scrollRevision = 0;

    function adjustScroll(delta) {
      const revision = ++scrollRevision;
      document.documentElement.setAttribute('data-cp-disclosure-scroll', '');
      window.scrollBy({ top: delta, behavior: 'instant' });
      const release = () => {
        if (scrollRevision !== revision) return;
        document.documentElement.removeAttribute('data-cp-disclosure-scroll');
      };
      requestAnimationFrame(() => requestAnimationFrame(release));
    }

    function lockViewport() {
      viewportLocks += 1;
      document.documentElement.setAttribute('data-cp-disclosure-transition', '');
      let released = false;
      return () => {
        if (released) return;
        released = true;
        viewportLocks -= 1;
        if (!viewportLocks) document.documentElement.removeAttribute('data-cp-disclosure-transition');
      };
    }

    function ease(progress) {
      let lower = 0;
      let upper = 1;
      let t = progress;
      for (let i = 0; i < 14; i += 1) {
        const x = 3 * (1 - t) * (1 - t) * t * 0.4 + 3 * (1 - t) * t * t * 0.2 + t * t * t;
        if (x < progress) lower = t;
        else upper = t;
        t = (lower + upper) / 2;
      }
      return 3 * (1 - t) * t * t + t * t * t;
    }

    function transitionUnanchoredRows(rows) {
      const releaseViewport=lockViewport();
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      const states=rows.map(row=>({row,from:row.details.getBoundingClientRect().height,animation:null}));
      let stopped=false;
      const stop=()=>{
        if(stopped)return;
        const heights=states.map(({row})=>row.details.getBoundingClientRect().height);
        stopped=true;
        states.forEach((state,index)=>{
          state.animation?.cancel();state.row.details.style.height=heights[index]+'px';
          if(state.row.transition===transaction)state.row.transition=null;
        });
        releaseViewport();
      };
      const finish=()=>{
        if(stopped)return;
        stopped=true;
        states.forEach(({row,animation})=>{
          animation?.cancel();row.applyState();
          if(row.transition===transaction)row.transition=null;
        });
        releaseViewport();
      };
      const transaction={stop,finish};
      rows.forEach(row=>{
        row.transition=transaction;row.summary.setAttribute('aria-expanded',String(row.targetOpen));
        row.details.style.overflow='hidden';row.details.open=true;row.details.style.height='auto';
      });
      states.forEach(state=>{
        const row=state.row,style=getComputedStyle(row.details);
        const edges=parseFloat(style.borderTopWidth)+parseFloat(style.borderBottomWidth)+parseFloat(style.paddingTop)+parseFloat(style.paddingBottom);
        state.to=row.targetOpen?row.details.getBoundingClientRect().height:row.summary.getBoundingClientRect().height+edges;
        row.contentWidth=row.content?.getBoundingClientRect().width;
      });
      if(reduced){finish();return;}
      states.forEach(state=>{
        state.row.details.style.height=state.to+'px';
        state.animation=state.row.details.animate([{height:state.from+'px'},{height:state.to+'px'}],{duration:360,easing:'cubic-bezier(.4,0,.2,1)'});
      });
      Promise.all(states.map(state=>state.animation.finished)).then(finish).catch(()=>{});
    }

    function transitionRows(rows, anchor) {
      if(anchor.dataset.disclosureScroll==='none'&&Element.prototype.animate){transitionUnanchoredRows(rows);return;}
      const releaseViewport = lockViewport();
      const controller = new AbortController();
      const mobile = matchMedia('(max-width: 749px)').matches;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const anchorTop = anchor.summary.getBoundingClientRect().top;
      let keepAnchor = anchor.dataset.disclosureScroll !== 'none' && anchorTop >= 0 && anchorTop < innerHeight;
      let frame;
      let stopped = false;
      let nativeScroll = false;
      let nativeRevision;
      let pinnedRow;
      let startedAt = performance.now();
      let duration = 360;
      let scrollStart = window.scrollY;
      let scrollTarget = scrollStart;
      let lastScroll = scrollStart;
      let lastMovement = startedAt;
      const states = rows.map(row => ({ row, from: row.details.getBoundingClientRect().height, to: 0, above: row !== anchor && row.summary.getBoundingClientRect().top < anchorTop }));
      const alignHeader = () => {
        if (mobile || !keepAnchor || !anchor.isConnected) return;
        const delta = anchor.summary.getBoundingClientRect().top - anchorTop;
        if (Math.abs(delta) > 0.25) adjustScroll(delta);
      };
      const updatePinnedRow = () => {
        if (pinnedRow) pinnedRow.space.style.height = anchor.getBoundingClientRect().height + 'px';
      };
      const pinRow = () => {
        const rect = anchor.getBoundingClientRect();
        const style = getComputedStyle(anchor);
        const space = document.createElement('div');
        space.setAttribute('aria-hidden', 'true');
        space.setAttribute('data-cp-disclosure-space', '');
        Object.assign(space.style, { display: 'block', height: rect.height + 'px', marginTop: style.marginTop, marginBottom: style.marginBottom, pointerEvents: 'none' });
        const properties = ['position', 'top', 'left', 'width', 'margin', 'z-index', 'box-sizing'];
        const original = properties.map(name => [name, anchor.style.getPropertyValue(name), anchor.style.getPropertyPriority(name)]);
        anchor.before(space);
        Object.assign(anchor.style, { position: 'fixed', top: rect.top + 'px', left: rect.left + 'px', width: rect.width + 'px', margin: '0', zIndex: '2', boxSizing: 'border-box' });
        pinnedRow = { space, original };
      };
      const unpinRow = () => {
        if (!pinnedRow) return;
        pinnedRow.original.forEach(([name, value, priority]) => {
          if (value) anchor.style.setProperty(name, value, priority);
          else anchor.style.removeProperty(name);
        });
        pinnedRow.space.remove();
        pinnedRow = null;
      };
      const renderProgress = progress => {
        states.forEach(({ row, from, to }) => {
          row.details.style.height = (from + (to - from) * progress) + 'px';
        });
        updatePinnedRow();
      };
      const releaseNativeScroll = cancel => {
        if (!nativeScroll) return;
        if (cancel) {
          const progress = Math.max(0, Math.min(1, (scrollStart - window.scrollY) / (scrollStart - scrollTarget)));
          renderProgress(progress);
        }
        nativeScroll = false;
        if (cancel) window.scrollTo({ top: window.scrollY, behavior: 'instant' });
        const revision = nativeRevision;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (scrollRevision === revision) document.documentElement.removeAttribute('data-cp-disclosure-scroll');
        }));
      };
      const stop = () => {
        if (stopped) return;
        stopped = true;
        cancelAnimationFrame(frame);
        releaseNativeScroll(Math.abs(window.scrollY - scrollTarget) > 1);
        unpinRow();
        controller.abort();
        rows.forEach(row => { if (row.transition === transaction) row.transition = null; });
        releaseViewport();
      };
      const finish = () => {
        if (stopped) return;
        releaseNativeScroll(Math.abs(window.scrollY - scrollTarget) > 1);
        rows.forEach(row => row.applyState());
        updatePinnedRow();
        unpinRow();
        alignHeader();
        stop();
      };
      const transaction = { stop, finish };
      rows.forEach(row => {
        row.transition = transaction;
        row.summary.setAttribute('aria-expanded', String(row.targetOpen));
        row.details.style.overflow = 'hidden';
        row.details.open = true;
        row.details.style.height = 'auto';
      });
      states.forEach(state => {
        const { row } = state;
        const style = getComputedStyle(row.details);
        const edges = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth) + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        state.to = row.targetOpen ? row.details.getBoundingClientRect().height : row.summary.getBoundingClientRect().height + edges;
        row.contentWidth = row.content?.getBoundingClientRect().width;
      });
      states.forEach(({ row, from }) => { row.details.style.height = from + 'px'; });
      const distance = states.reduce((total, { above, from, to }) => total + (above ? from - to : 0), 0);
      scrollTarget = Math.max(0, Math.round(scrollStart - distance));
      if (reduced) {
        if (mobile && keepAnchor && distance > 1) adjustScroll(scrollTarget - scrollStart);
        finish();
        return;
      }
      const releaseAnchor = () => {
        keepAnchor = false;
        if (nativeScroll) {
          releaseNativeScroll(true);
          unpinRow();
          states.forEach(state => { state.from = state.row.details.getBoundingClientRect().height; });
          startedAt = performance.now();
          duration = 240;
        }
      };
      ['wheel', 'touchmove'].forEach(type => {
        window.addEventListener(type, releaseAnchor, { passive: true, signal: controller.signal });
      });
      window.addEventListener('keydown', event => {
        const scrollKey = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key);
        const scrollSpace = event.key === ' ' && !event.target.closest?.('summary');
        if (scrollKey || scrollSpace) releaseAnchor();
      }, { passive: true, signal: controller.signal });
      window.addEventListener('scrollend', () => {
        if (nativeScroll && Math.abs(window.scrollY - scrollTarget) <= 1) finish();
      }, { passive: true, signal: controller.signal });
      if (mobile && keepAnchor && anchor.dataset.disclosureGroup && distance > 1 && scrollStart - scrollTarget > 1) {
        pinRow();
        nativeScroll = true;
        nativeRevision = ++scrollRevision;
        document.documentElement.setAttribute('data-cp-disclosure-scroll', '');
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      }
      const tick = now => {
        if (stopped) return;
        let progress;
        if (nativeScroll) {
          const currentScroll = window.scrollY;
          if (currentScroll !== lastScroll) {
            lastScroll = currentScroll;
            lastMovement = now;
          }
          progress = Math.max(0, Math.min(1, (scrollStart - currentScroll) / (scrollStart - scrollTarget)));
          if (Math.abs(currentScroll - scrollTarget) <= 0.01) progress = 1;
          else if (now - lastMovement > 240 || now - startedAt > 1800) {
            releaseAnchor();
            progress = 0;
          }
        } else {
          progress = Math.min(1, (now - startedAt) / duration);
          if (progress < 1) progress = ease(progress);
        }
        if (progress >= 1) {
          finish();
          return;
        }
        renderProgress(progress);
        alignHeader();
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
    }

    customElements.define('cp-eased-disclosure', class extends HTMLElement {
      connectedCallback() {
        if (this.onClick) return;
        this.details = this.querySelector('details');
        this.summary = this.details?.querySelector('summary');
        if (!this.summary) return;
        this.content = this.summary.nextElementSibling;
        this.targetOpen = this.details.open;
        this.summary.setAttribute('aria-expanded', String(this.targetOpen));
        this.onClick = event => {
          event.preventDefault();
          this.setOpen(!this.targetOpen);
        };
        this.onToggle = () => {
          if (!this.transition) {
            this.targetOpen = this.details.open;
            this.summary.setAttribute('aria-expanded', String(this.targetOpen));
          }
        };
        this.onKeyDown = event => {
          if (event.key === 'Escape' && this.targetOpen) {
            event.preventDefault();
            this.setOpen(false);
            this.summary.focus({ preventScroll: true });
          }
        };
        this.summary.addEventListener('click', this.onClick);
        this.details.addEventListener('toggle', this.onToggle);
        this.addEventListener('keydown', this.onKeyDown);
        if (this.content && window.ResizeObserver) {
          this.contentWidth = this.content.getBoundingClientRect().width;
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.content.getBoundingClientRect().width;
            if (this.transition && Math.abs(width - this.contentWidth) > 1) this.transition.finish();
            this.contentWidth = width;
          });
          this.resizeObserver.observe(this.content);
        }
      }

      disconnectedCallback() {
        if (!this.onClick) return;
        const transition = this.transition;
        transition?.finish();
        transition?.stop();
        this.summary.removeEventListener('click', this.onClick);
        this.details.removeEventListener('toggle', this.onToggle);
        this.removeEventListener('keydown', this.onKeyDown);
        this.resizeObserver?.disconnect();
        this.onClick = null;
      }

      applyState() {
        this.details.open = this.targetOpen;
        this.details.style.height = '';
        this.details.style.overflow = '';
        this.summary.setAttribute('aria-expanded', String(this.targetOpen));
      }

      setOpen(open) {
        if (matchMedia('(max-width: 749px)').matches) {
          this.closest('.scroll-trigger.animate--slide-in')?.classList.add('scroll-trigger--cancel');
        }
        const group = this.dataset.disclosureGroup;
        const peers = group ? [...this.parentElement.querySelectorAll(':scope > cp-eased-disclosure[data-disclosure-group]')].filter(peer => peer.dataset.disclosureGroup === group && peer.summary) : [this];
        const rows = peers.filter(peer => peer === this || peer.details.open || peer.transition || peer.targetOpen);
        new Set(rows.map(row => row.transition).filter(Boolean)).forEach(transaction => transaction.stop());
        this.targetOpen = open;
        if (open) rows.forEach(row => { if (row !== this) row.targetOpen = false; });
        transitionRows(rows, this);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-inline-trust-badges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('herbl-inline-trust')) {
    customElements.define('herbl-inline-trust', class extends HTMLElement {
      connectedCallback() {
        if (this.resize) return;
        this.items = this.querySelector('.cp-trust__items');
        if (!this.items) return;
        this.resize = new ResizeObserver(() => this.fit());
        this.resize.observe(this);
        this.fit();
        document.fonts?.ready.then(() => { if (this.isConnected) this.fit(); });
      }
      fit() {
        const available = this.clientWidth - 1;
        if (available <= 0) return;
        let size = parseFloat(getComputedStyle(this).getPropertyValue('--cp-trust-base-size')) || 12;
        this.style.setProperty('--cp-trust-fit-size', `${size}px`);
        for (let pass = 0; pass < 2; pass++) {
          const width = this.items.getBoundingClientRect().width;
          if (width <= available) break;
          size = Math.floor(size * available / width * 100) / 100;
          this.style.setProperty('--cp-trust-fit-size', `${size}px`);
        }
      }
      disconnectedCallback() {
        this.resize?.disconnect();
        this.resize = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-layered-product-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select', (event) => {
    const hero = event.target.closest('[data-cp-hero-block]');
    if (!hero) return;
    const gallery = hero.closest('media-gallery');
    gallery?.setActiveMedia?.(hero.dataset.galleryMedia, false);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-purchase-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hc-clinical-shop')) {
    customElements.define('hc-clinical-shop', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-purchase-link]');
        this.target = document.querySelector('cp-subscription-widget-v2');
        if (!this.link || !this.target) return;
        this.link.href = '#' + this.target.id;
        this.onClick = (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const header = document.querySelector('.section-header');
          const offset = (header ? header.getBoundingClientRect().height : 80) + 20;
          const top = this.target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          const control = this.target.querySelector('button:not([disabled]), input:not([disabled])');
          if (control) control.focus({ preventScroll: true });
        };
        this.link.addEventListener('click', this.onClick);
      }
      disconnectedCallback() {
        if (this.link && this.onClick) this.link.removeEventListener('click', this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-research-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('herbl-research-popup')) {
    customElements.define('herbl-research-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger = this.querySelector('.cp-research__learn');
        this.dialog = this.querySelector('dialog');
        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('.cp-research__close').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }, options);
        this.dialog.addEventListener('close', () => { this.restoreScroll(); this.updatePortraitMotion(); }, options);
        this.portraitStrip = this.querySelector('.cp-research__portraits');
        this.portraitsVisible = false;
        if (this.portraitStrip) {
          this.portraitObserver = new IntersectionObserver(entries => {
            this.portraitsVisible = entries[0].isIntersecting;
            this.updatePortraitMotion();
          });
          this.portraitObserver.observe(this.portraitStrip);
          document.addEventListener('visibilitychange', () => this.updatePortraitMotion(), options);
        }
      }
      updatePortraitMotion() {
        if (!this.portraitStrip) return;
        this.portraitStrip.dataset.motion = this.portraitsVisible && !document.hidden && !this.dialog.open ? 'running' : 'paused';
      }
      open() {
        if (this.dialog.open || this.closing) return;
        const root = document.documentElement;
        this.previousOverflow = root.style.overflow;
        this.previousPadding = root.style.paddingRight;
        const scrollbar = window.innerWidth - root.clientWidth;
        if (scrollbar > 0) root.style.paddingRight = `${parseFloat(getComputedStyle(root).paddingRight) + scrollbar}px`;
        root.style.overflow = 'hidden';
        this.locked = true;
        this.dialog.showModal();
        this.updatePortraitMotion();
        this.dialog.querySelector('.cp-research__body').scrollTop = 0;
        const from = this.trigger.getBoundingClientRect();
        const to = this.dialog.getBoundingClientRect();
        const x = Math.max(10, Math.min(90, (from.left + from.width / 2 - to.left) / to.width * 100));
        const y = Math.max(10, Math.min(90, (from.top + from.height / 2 - to.top) / to.height * 100));
        this.dialog.style.transformOrigin = `${x}% ${y}%`;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.motion = this.dialog.animate([{ opacity: 0, transform: 'translateY(14px) scale(.94)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }], { duration: 300, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      }
      async close() {
        if (!this.dialog.open || this.closing) return;
        this.closing = true;
        this.motion?.cancel();
        this.dialog.classList.add('is-closing');
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.motion = this.dialog.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'translateY(8px) scale(.97)' }], { duration: 180, easing: 'cubic-bezier(.4,0,1,1)' });
          try { await this.motion.finished; } catch (_) {}
        }
        this.dialog.close();
        this.dialog.classList.remove('is-closing');
        this.motion = null;
        this.closing = false;
      }
      restoreScroll() {
        if (!this.locked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        document.documentElement.style.paddingRight = this.previousPadding;
        this.locked = false;
      }
      disconnectedCallback() {
        this.portraitObserver?.disconnect();
        if (this.portraitStrip) this.portraitStrip.dataset.motion = 'paused';
        this.motion?.cancel();
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-tab-ingredients"] && !Shopify.designMode) return;
  try {
    var ingredientAnimations = new WeakMap();

  function initializeIngredientDisclosures(scope) {
    scope.querySelectorAll('.ctb-ingredients').forEach(function(ingredients) {
      if (ingredients.classList.contains('is-collapsible')) return;
      var region = ingredients.querySelector('.ctb-ingredients__more-region');
      var button = ingredients.querySelector('[data-cp-ingredients-toggle]');
      if (!region || !button) return;
      region.inert = true;
      region.setAttribute('aria-hidden', 'true');
      ingredients.classList.add('is-collapsible');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeIngredientDisclosures(document);
    });
  } else {
    initializeIngredientDisclosures(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeIngredientDisclosures(event.target);
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-cp-ingredients-toggle]');
    if (!button) return;
    var ingredients = button.closest('.ctb-ingredients');
    var region = ingredients.querySelector('.ctb-ingredients__more-region');
    var expanded = button.getAttribute('aria-expanded') !== 'true';
    var buttonTop = button.getBoundingClientRect().top;
    var previousHeight = region.getBoundingClientRect().height;
    var previousAnimation = ingredientAnimations.get(region);
    if (previousAnimation) {
      previousAnimation.onfinish = null;
      previousAnimation.cancel();
      ingredientAnimations.delete(region);
    }

    ingredients.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.querySelector('span').textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
    region.inert = !expanded;
    region.setAttribute('aria-hidden', String(!expanded));
    var nextHeight = region.getBoundingClientRect().height;

    function preserveCollapsePosition() {
      if (expanded || buttonTop < 0 || !button.getClientRects().length) return;
      var shift = button.getBoundingClientRect().top - buttonTop;
      if (shift < -0.5) window.scrollBy({ top: shift, behavior: 'instant' });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !region.animate) {
      preserveCollapsePosition();
      return;
    }
    var animation = region.animate([
      { height: previousHeight + 'px' },
      { height: nextHeight + 'px' }
    ], { duration: 400, easing: 'ease-in-out' });
    ingredientAnimations.set(region, animation);
    animation.onfinish = function() {
      preserveCollapsePosition();
      ingredientAnimations.delete(region);
    };
    if (!expanded) {
      requestAnimationFrame(function trackCollapse() {
        if (ingredientAnimations.get(region) !== animation) return;
        preserveCollapsePosition();
        requestAnimationFrame(trackCollapse);
      });
    }
  });

  var cpNutritionAnimations = new WeakMap();
  var cpNutritionOpening = new WeakSet();

  function cpPrepareNutritionDialog(dialog) {
    return Promise.all(Array.from(dialog.querySelectorAll('img')).map(function(image) {
      image.loading = 'eager';
      if (image.decode) return image.decode().catch(function() {});
      if (image.complete) return Promise.resolve();
      return new Promise(function(resolve) {
        function finish() {
          image.removeEventListener('load', finish);
          image.removeEventListener('error', finish);
          resolve();
        }
        image.addEventListener('load', finish);
        image.addEventListener('error', finish);
      });
    }));
  }

  function cpWarmNutritionFromTrigger(trigger) {
    if (!trigger) return;
    var dialog = document.getElementById(trigger.dataset.cpNutritionOpen);
    if (dialog) cpPrepareNutritionDialog(dialog);
  }

  function cpObserveNutritionTriggers(scope) {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        cpWarmNutritionFromTrigger(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '200px' });
    scope.querySelectorAll('[data-cp-nutrition-open]').forEach(function(trigger) {
      observer.observe(trigger);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      cpObserveNutritionTriggers(document);
    });
  } else {
    cpObserveNutritionTriggers(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    cpObserveNutritionTriggers(event.target);
  });

  ['pointerover', 'pointerdown', 'focusin'].forEach(function(eventName) {
    document.addEventListener(eventName, function(event) {
      cpWarmNutritionFromTrigger(event.target.closest('[data-cp-nutrition-open]'));
    }, { passive: true });
  });

  function cpCloseNutritionDialog(dialog) {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    var previous = cpNutritionAnimations.get(dialog);
    var current = getComputedStyle(dialog);
    var start = { opacity: current.opacity, transform: current.transform };
    if (previous) previous.cancel();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !dialog.animate) {
      dialog.close();
      cpNutritionAnimations.delete(dialog);
      return;
    }
    dialog.classList.add('is-closing');
    var animation = dialog.animate([start, { opacity: 0, transform: 'scale(0.88)' }], {
      duration: 180,
      easing: 'cubic-bezier(0.4, 0, 1, 1)',
      fill: 'forwards'
    });
    cpNutritionAnimations.set(dialog, animation);
    animation.finished.then(function() {
      dialog.close();
      dialog.classList.remove('is-closing');
      animation.cancel();
      cpNutritionAnimations.delete(dialog);
    }).catch(function() {});
  }

  document.addEventListener('submit', function(event) {
    var dialog = event.target.closest('.ctb-nutrition-dialog');
    if (!dialog || event.target.getAttribute('method') !== 'dialog') return;
    event.preventDefault();
    cpCloseNutritionDialog(dialog);
  });

  document.addEventListener('click', async function(event) {
    var trigger = event.target.closest('[data-cp-nutrition-open]');
    if (!trigger) return;
    var dialog = document.getElementById(trigger.dataset.cpNutritionOpen);
    if (!dialog || dialog.open || cpNutritionOpening.has(dialog)) return;
    cpNutritionOpening.add(dialog);
    trigger.setAttribute('aria-busy', 'true');
    try {
      await cpPrepareNutritionDialog(dialog);
      if (!dialog.isConnected || !trigger.isConnected || !trigger.getClientRects().length) return;
      var buttonRect = trigger.getBoundingClientRect();
      if (!dialog.dataset.cpNutritionMotion) {
        dialog.dataset.cpNutritionMotion = 'true';
        dialog.addEventListener('cancel', function(cancelEvent) {
          cancelEvent.preventDefault();
          cpCloseNutritionDialog(dialog);
        });
      }
      dialog.classList.remove('is-closing');
      dialog.showModal();
      var dialogRect = dialog.getBoundingClientRect();
      var originX = buttonRect.left + buttonRect.width / 2 - dialogRect.left;
      var originY = buttonRect.top + buttonRect.height / 2 - dialogRect.top;
      dialog.style.transformOrigin = originX + 'px ' + originY + 'px';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !dialog.animate) return;
      var animation = dialog.animate([
        { opacity: 0, transform: 'scale(0.88)' },
        { opacity: 1, transform: 'scale(1)' }
      ], { duration: 240, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
      cpNutritionAnimations.set(dialog, animation);
    } finally {
      cpNutritionOpening.delete(dialog);
      trigger.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
